import { createTheme } from 'react-data-table-component';

const rowCollapsedSvg = `<svg width="15" height="4" viewBox="0 0 15 4" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M2.05212 0.41391C1.11186 0.41391 0.35083 1.17452 0.35083 2.11434C0.35083 3.05416 1.11101 3.8152 2.05212 3.8152C2.99065 3.8152 3.75255 3.05545 3.75255 2.11434C3.75255 1.17452 2.99065 0.41391 2.05212 0.41391ZM7.31076 0.41391C6.37265 0.41391 5.60947 1.17409 5.60947 2.11391C5.60947 3.05373 6.37179 3.81477 7.31076 3.81477C8.24972 3.81477 9.0129 3.05502 9.0129 2.11391C9.01204 1.17452 8.24972 0.41391 7.31076 0.41391ZM12.3945 0.41391C11.4546 0.41391 10.6927 1.17452 10.6927 2.11477C10.6927 3.05373 11.4534 3.81477 12.3945 3.81477C13.3326 3.81477 14.0945 3.05502 14.0945 2.11477C14.0945 1.17452 13.3326 0.41391 12.3945 0.41391Z" fill="#004A73"/>
</svg>`;
const rowExpandedSvg = `<svg width="4" height="15" viewBox="0 0 4 15" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0.418945 12.9857C0.418945 13.926 1.17955 14.687 2.11937 14.687C3.0592 14.687 3.82023 13.9268 3.82023 12.9857C3.82023 12.0472 3.06048 11.2853 2.11937 11.2853C1.17955 11.2853 0.418945 12.0472 0.418945 12.9857ZM0.418945 7.72709C0.418945 8.66519 1.17912 9.42837 2.11895 9.42837C3.05877 9.42837 3.8198 8.66605 3.8198 7.72709C3.8198 6.78812 3.06006 6.02494 2.11895 6.02494C1.17955 6.0258 0.418945 6.78812 0.418945 7.72709ZM0.418945 2.64338C0.418945 3.5832 1.17955 4.34509 2.1198 4.34509C3.05877 4.34509 3.8198 3.58449 3.8198 2.64338C3.8198 1.70527 3.06006 0.943377 2.1198 0.943377C1.17955 0.943377 0.418945 1.70527 0.418945 2.64338Z" fill="#004A73"/>
</svg>`;
const rowCollapsedUrl = encodeURI(
  'data:image/svg+xml,' + rowCollapsedSvg
).replace('#', '%23');
const rowExpandedUrl = encodeURI(
  'data:image/svg+xml,' + rowExpandedSvg
).replace('#', '%23');

export const rowCollapsedElement = (
  <img src={rowCollapsedUrl} alt='Collapsed icon'></img>
);
export const rowExpandedElement = <img src={rowExpandedUrl} alt='Expanded icon'></img>;

export const headerFontStyle = {
  fontFamily: 'Open Sans',
  fontStyle: 'normal',
  fontWeight: 'bold',
  fontSize: '11px',
  lineHeight: '15px',
  /* identical to box height */

  letterSpacing: '0.06em',
  textTransform: 'uppercase',

  /* grey */

  color: '#77797B',
};

export const waypointFontStyle = {
  fontFamily: 'Open Sans',
  fontStyle: 'normal',
  fontWeight: '400',
  fontSize: '14px',
  lineHeight: '28px',
  color: '#004469',
};

export const tableCustomStyles = {
  rows: {
    style: {
      /* background: 'red', */
    },
  },
  headCells: {
    style: {
      /* background: '#FFFFFF',
      boxShadow: '0px 4px 30px rgba(0, 0, 0, 0.05)',
      borderRadius: '20px',
      transform: 'matrix(1, 0, 0, -1, 0, 0)', */
    },
  },
  headRow: {
    style: {
      /* background: 'blue', */
      boxShadow: '0px 4px 30px rgba(0, 0, 0, 0.05)',
      borderRadius: '20px',
      zIndex: '300',
      /* transform: 'matrix(1, 0, 0, -1, 0, 0)', */
    },
  },
  cells: {
    style: {
      background: '#FFFFFF',
      fontFamily: 'Open Sans',
      fontStyle: 'normal',
      fontWeight: '400',
      fontSize: '14px',
      lineHeight: '28px',
      color: '#000000',
    },
  },
};

export const colsMedium = 450;
export const colsLarge = 650;

createTheme('waldup', {
    text: {
      primary: '#000000',
      secondary: '#2aa198',
    },
    background: {
      default: '#FFFFFF',
    },
    context: {
      background: '#cb4b16',
      text: '#FFFFFF',
    },
    divider: {
      default: '#E0E0E0',
    },
    action: {
      button: 'rgba(0,0,0,.54)',
      hover: 'rgba(0,0,0,.08)',
      disabled: 'rgba(0,0,0,.12)',
    },
    selected: {
      background: 'pink',
      default: 'rgba(0, 0, 0, .7)',
      text: '#FFFFFF',
    },
  });